<template>
<div>
  <v-btn color="#00e676" dark small fab @click.native="dialog = true, getWithTreatments(); getWithTreatments_discount();"><v-icon dark>add</v-icon></v-btn>

    <v-dialog v-model="dialog" persistent max-width="800px">

      
      <v-card>
        <v-card-title>
          <span class="headline">Kies een bij behandeling</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
            <v-flex xs12 sm2 md12>
         

              <v-data-table
              v-model="selectedwithtreatment"
              :headers="headers"
              :items="loadedWithTreatments"
              :pagination.sync="pagination"
              hide-actions
              item-key="title">
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                   
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text">
                    
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded" >
                   
                  <td>
                    <v-checkbox :active="props.selected" @click="props.selected = !props.selected; computeSelectedWithTreatments(); "
                      :input-value="props.selected"
                      
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                <td >  <v-list-tile-avatar>
                <img :src="company[1] + props.item.field_afbeelding_behandeling">
              </v-list-tile-avatar></td>
                  <td  >{{ props.item.title }}</td> 
                  <td >{{ props.item.field_prijs_behandeling }}</td>
                  <td >{{ props.item.field_combiprijs }}</td>
                  
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
      <v-card flat>
        <v-card-text>{{ props.item.field_omschrijving_behandeling }}</v-card-text>
      </v-card>
    </template>

            </v-data-table>

    

         <!-- <v-list three-line >
            <template v-for="(acties,index) in loadedWithTreatments_discounts" >
        <v-checkbox  :key="index" :label="acties.title"  v-model="$store.state.selected_discount_withtreatment" :value="acties" ></v-checkbox>
         </template>
         </v-list> -->
      
 <v-radio-group v-if="selectedwithtreatment.length !== 0" v-model="$store.state.selected_discount_withtreatment" :mandatory="false" column>
        <v-radio
            label="Geen"
            @click.native="DeSelectedProducts();"
            :value="$store.state.radioboxen.noradio"
          ></v-radio>

   <template v-for="(acties,index) in loadedWithTreatments_discounts" >
              <v-radio
                :key="index"
                :label="acties.title"
                :value="acties"
                @click.native="computeSelectedWithTreatments_discount();"
                
              ></v-radio>
              </template>
             
            </v-radio-group>
         

<!-- @click="$store.state.selectedWithTreatment = treatment; $store.state.withTreatmentboolean = true;" -->

        </v-flex>
            </v-layout>
          </v-container>
         
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn v-if="selectedwithtreatment.length == 0" color="primary" dark  @click.native="dialog = false">Sluiten</v-btn>
          <v-btn v-else color="primary"   @click.native="dialog = false">Verder</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.fromprice {
  text-decoration-line: line-through;
}
</style>

<script>
import accounting from "accounting";
import axios from "axios";

export default {
  data: () => ({
    dialog: false,
    company: ["Hair & Beauty Company", "http://www.hairbeautycompany.nl"],
    loadedWithTreatments: [],
    loadedWithTreatments_discounts: [],
    pagination: {
      sortBy: "name"
    },

    selectedwithtreatment: [],
    selected_discount: [],
    headers: [
      { text: "", value: "" },
      {
        text: "Bij behandeling",
        value: "name"
      },

      { text: "Orginele prijs", value: "Orginele prijs", align: "left" },
      { text: "Combi prijs", value: "Combi prijs", align: "left" }
    ]
  }),

  methods: {
    resetCheckbox: function(value) {
      this.selectedwithtreatment = value;
    },

    getWithTreatments: function() {
      var vm = this;
      const config = {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        }
      };

      axios
        .get("https://www.hairbeautycompany.nl/api/withtreatment?_format=json", config)

        .then(function(response) {
          console.log(response);

          vm.loadedWithTreatments = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getWithTreatments_discount: function() {
      let checkmembership;
      if (this.$store.state.membershipdiscount == false) {
        checkmembership = "";
      } else {
        checkmembership = "/abo";
      }

      var vm = this;
      const config = {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        }
      };

      axios
        .get("https://www.hairbeautycompany.nl/api/actie/bijbehandeling" + checkmembership + "?_format=json", config)

        .then(function(response) {
          console.log(response);
          console.log("https://www.hairbeautycompany.nl/api/actie/bijbehandeling" + checkmembership + "?_format=json");

          vm.loadedWithTreatments_discounts = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    DeSelectedProducts: function() {
      // this.$store.state.WithTreatmentCalc.TitleTreatment = []
      // this.$store.state.WithTreatmentCalc.prijsbehandeling = 0
      this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result = null;
      this.selected = [];
      this.$store.state.WithTreatmentCalc.TitleTreatment = null;
      this.$store.state.WithTreatmentCalc.prijsbehandeling = null;
      this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_name = null;
    },

    computeSelectedWithTreatments: function() {
      //Array foreach and convert to number with ForEach function. += operator for sum
      var sumTitleTreatment = [];
      var sumPrijsbehandeling = 0;

      this.selectedwithtreatment.forEach(function(element) {
        console.log(element.field_prijs_behandeling);

        // sumTitleTreatment  += `${element.title} `

        sumTitleTreatment.push(element.title);
        sumPrijsbehandeling += Number(element.field_prijs_behandeling); //Sums the selected prices

        console.log(sumTitleTreatment);
      });
      this.$store.state.WithTreatmentCalc.TitleTreatment = sumTitleTreatment;
      this.$store.state.WithTreatmentCalc.prijsbehandeling = sumPrijsbehandeling; //store the prices to VUEX
    },

    computeSelectedWithTreatments_discount: function() {
      // Bereken actie met Euros of Percentage

      let discountcalc; //Euros or Percentage?
      if (this.$store.state.selected_discount_withtreatment.field_korting_type == "Bedrag") {
        let bedrag;

        bedrag = Number(this.$store.state.selected_discount_withtreatment.field_korting_in_euro);

        this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result = Number(
          this.$store.state.selected_discount_withtreatment.field_korting_in_euro
        ); //Schijft de uiteindelijke percentage berekening naar de Vuex state.

        //Resultaat met gekozen Merk actie in Vuex state zetten
        this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_name =
          this.$store.state.selected_discount_withtreatment.title +
          " " +
          this.$store.state.selected_discount_withtreatment.field_merken_actie;
      } else {
        let percentage;
        let naamdiscountresultaat;

        percentage =
          (Number(this.$store.state.selected_discount_withtreatment.field_korting_in_percentage) / 100) *
          this.$store.state.WithTreatmentCalc.prijsbehandeling; //Percentage uitrekenen

        this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result = percentage; //Schijft de uiteindelijke percentage berekening naar de Vuex state.

        //Resultaat met gekozen Merk actie in Vuex state zetten
        this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_name =
          this.$store.state.selected_discount_withtreatment.title +
          " " +
          this.$store.state.selected_discount_withtreatment.field_merken_actie;
      }
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },

  computed: {}
};
</script>